import React, { useState } from "react";

import { Radio } from "antd";

interface ButtonTabsProps {
  tabs: { key: string; label: string }[];
  activeTab: string;
  onChange: (key: string) => void;
}

const ButtonTabs = ({ tabs, activeTab, onChange }: ButtonTabsProps) => {
  const [selected, setSelected] = useState("");

  return (
    <Radio.Group value={selected || activeTab} buttonStyle="solid">
      {tabs.map((tab, index) => {
        return (
          <Radio.Button
            key={tab.key}
            onClick={() => {
              onChange(tab.key);
              setSelected(tab.key);
            }}
            value={tab.key}
          >
            {tab.label}
          </Radio.Button>
        );
      })}
    </Radio.Group>
  );
};

export default ButtonTabs;
